import React from 'react';
import {Link} from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {messages} from  '../../common/Translations';
import CompaniesListDivRow from './CompaniesListDivRow';


class CompaniesListDivs extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        if(this.expectedConfirmationSelect) {
            this.expectedConfirmationSelect.value = this.expectedConfirmationSelect.getAttribute('data-count');
            this.expectedConfirmationSelect = null;
        }
    }

    getCompanyById(id) {
        return this.props.companies.find(company => company.id == id);
    }

    render() {
        let {
            companies,
            categoryOptions,
        } = this.props;

        return (

            <div>
            {
                companies.map(company => <CompaniesListDivRow
                    key={company.id}
                    company={company}
                    categoryOptions={categoryOptions}
                />)
            }
            </div>
        );
    }
}

export default injectIntl(CompaniesListDivs);


// WEBPACK FOOTER //
// ./web/src/components/company/list/CompaniesListDivs.jsx